import React from "react";
import i18n from "i18next";

const NoNotificationCard = () => {
  return <div className="notification-card --no-notification">{i18n.t("notification.noNotifications")}</div>;
};

export default NoNotificationCard;



// WEBPACK FOOTER //
// ./src/components/Layout/Notifications/NoNotificationCard.js